import type { FC } from "react";

import { UiEarthOutlineIcon } from "@jti/brand-icons/ui-earth-outline";
import { Button } from "@jti/core-components/components/Button";

type LanguageSelectorButtonProps = {
  toggleDropdown: () => void;
  languageName: string;
};

export const LanguageSelectorButton: FC<LanguageSelectorButtonProps> = ({ toggleDropdown, languageName }) => {
  return (
    <Button onClick={toggleDropdown} size="md" variant="secondary" iconBefore={UiEarthOutlineIcon}>
      {languageName}
    </Button>
  );
};
